import { Color, Entity, PolylineGraphics, ArcType, PolylineArrowMaterialProperty, } from "cesium";
import { useEffect, useRef } from "react";
import { useCesium } from "../Contexts/Widget3DContext";
export const Vector = ({ name, positions, availability, color, }) => {
    const { isViewerLoaded, addEntity, removeEntity } = useCesium();
    const vectorEntity = useRef(null);
    const pointColor = color || Color.WHITE;
    const addVector = () => {
        const newVectorEntity = new Entity({
            id: `vector ${name}`,
            name: `vector ${name}`,
            availability,
            polyline: new PolylineGraphics({
                positions: positions,
                width: 4,
                arcType: ArcType.NONE,
                material: new PolylineArrowMaterialProperty(pointColor),
            }),
        });
        return addEntity(newVectorEntity);
    };
    useEffect(() => {
        if (isViewerLoaded) {
            (vectorEntity === null || vectorEntity === void 0 ? void 0 : vectorEntity.current) && removeEntity(vectorEntity.current);
            vectorEntity.current = addVector();
        }
        return () => {
            (vectorEntity === null || vectorEntity === void 0 ? void 0 : vectorEntity.current) && removeEntity(vectorEntity.current);
        };
    }, [isViewerLoaded, name, positions, availability, color]);
    return null;
};
//# sourceMappingURL=Vector.js.map